import { useDispatch } from 'react-redux';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';

const handleFromattedResponse = (res, dispatch) => {
  if (res && res?.status > 300) {
    const messageError = `Error: ${res?.status} - ${res?.statusText}: updateStatus`;
    dispatch(
      setSnackBar({ open: true, message: messageError, color: 'error' })
    );
  } else {
    dispatch(setSnackBar({ open: false, message: null, color: null }));
  }
};

const useUpdateOrderStatus = ({ order }) => {
  const dispatch = useDispatch();
  const updateStatus = async ({
    statusCode,
    userId,
    note,
    ticketId,
    stateToLock,
  }) => {
    try {
      // Debug logs
      console.log('Debug - Input values:', {
        statusCode: typeof statusCode,
        userId: typeof userId,
        note: typeof note,
        ticketId: typeof ticketId,
        stateToLock: typeof stateToLock,
      });

      const payload = {
        statusCode,
        userId,
        note: note || '',
        ticketId: ticketId || null,
        stateToLock: stateToLock || null,
      };

      console.log('Debug - Payload:', payload);

      let updatedOrder;
      await AxiosConfig.create('put', `/orders/${order?._id}/status/`)
        .call(payload)
        .exit((res) => (updatedOrder = res?.data))
        .catch((error) => handleFromattedResponse(error, dispatch));

      return updatedOrder;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du statut:', error);
      throw error;
    }
  };

  return { updateStatus };
};

export default useUpdateOrderStatus;
